<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    alertType: {
      type: String,
      default: "success",
    },
    primaryMsg: {
      type: String,
      default: "Nothing sent as a primary message",
    },
    secondaryMsg: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <div :class="'alert alert-' + alertType" role="alert">
    <h4 class="alert-heading">{{ title }}</h4>
    <p>
      {{ primaryMsg }}
    </p>
    <hr v-if="secondaryMsg !== ''" />
    <p class="mb-0" v-if="secondaryMsg !== ''">
      {{ secondaryMsg }}
    </p>
  </div>
</template>
